import React, { useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import { ApplicationWizard } from '../components/careers/ApplicationWizard';
import { HIRING_STEPS, HOW_WE_WORK, SEATS } from '../data/careers';
export function Careers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full bg-engage-black" data-id="element-167" data-mp="2mpyu4wj2kirf">
      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-44 md:pb-24 px-4" data-id="element-168" data-mp="2mn2u92nnvk0c">
        <div className="max-w-4xl mx-auto" data-id="element-169" data-mp="2rnqqq3unst1y">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-engage-white tracking-tight mb-8" data-id="element-170" data-mp="2wnmx29qtwwko">
            Careers at Engage Media
          </h1>
          <p className="text-lg md:text-2xl text-engage-gray4 leading-relaxed max-w-3xl" data-id="element-171" data-mp="31ev81a7t4pzy">
            We're a performance marketing agency in Doral, FL. We run the ads,
            make the content, and build the backend for businesses doing $500K+
            a year. Marketing here is{' '}
            <span className="text-engage-white font-semibold" data-id="element-172" data-mp="3femhqyrajk85">
              math + storytelling
            </span>
            .
          </p>
        </div>
      </section>

      {/* How We Work */}
      <section aria-labelledby="how-we-work" className="py-16 md:py-20 px-4 border-y border-engage-gray2 bg-engage-gray1/40" data-id="element-173" data-mp="1em6p7gdaxa1s">
        <div className="max-w-7xl mx-auto" data-id="element-174" data-mp="15mjpr044uebd">
          <h2 id="how-we-work" className="text-3xl md:text-4xl font-bold text-engage-white mb-10" data-id="element-175" data-mp="15nlbpzmosl7v">
            How we work
          </h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-176" data-mp="1yapb9p30g7c9">
            {HOW_WE_WORK.map(item => <li key={item} className="bg-engage-gray1 border-l-2 border-engage-yellow rounded-r-sm px-6 py-6 flex" data-id="element-177" data-mp="1tixto41u1by9">
                <p className="text-engage-gray5 text-base md:text-lg font-medium leading-snug" data-id="element-178" data-mp="2m11sxro25ig1">
                  {item}
                </p>
              </li>)}
          </ul>
        </div>
      </section>

      {/* Seats We Hire For */}
      <section aria-labelledby="seats" className="py-20 md:py-28 px-4" data-id="element-179" data-mp="306tzktw5dqtm">
        <div className="max-w-7xl mx-auto" data-id="element-180" data-mp="3543mo2w2dqea">
          <h2 id="seats" className="text-3xl md:text-4xl font-bold text-engage-white mb-10" data-id="element-181" data-mp="356zk7q402d27">
            Seats we hire for
          </h2>
          <ul className="flex flex-wrap gap-3 mb-8" data-id="element-182" data-mp="2vdsiqgcdrh7e">
            {SEATS.map(seat => <li key={seat} className="px-5 py-2.5 bg-engage-gray1 border border-engage-gray2 rounded-full text-engage-gray5 text-sm md:text-base font-medium" data-id="element-183" data-mp="2hesuvawoz6ca">
                {seat}
              </li>)}
          </ul>
          <p className="text-engage-gray4 text-base md:text-lg max-w-2xl" data-id="element-184" data-mp="2cfponn4z6u2q">
            Pick your main seat in the form below. We keep strong applications
            on file even when a seat is full.
          </p>
        </div>
      </section>

      {/* What Happens After You Apply */}
      <section aria-labelledby="process" className="py-20 md:py-28 px-4 border-y border-engage-gray2 bg-engage-gray1/40" data-id="element-185" data-mp="1v6ncnieb1qlk">
        <div className="max-w-7xl mx-auto" data-id="element-186" data-mp="1r7ekuj2ts2sn">
          <h2 id="process" className="text-3xl md:text-4xl font-bold text-engage-white mb-12" data-id="element-187" data-mp="24wosjmwi82pe">
            What happens after you apply
          </h2>

          <ol className="flex flex-col lg:flex-row lg:items-stretch gap-4 lg:gap-0 mb-12" data-id="element-188" data-mp="2ev4gxi45cxv7">
            {HIRING_STEPS.map((item, index) => <li key={item.label} className="flex-1 flex items-center gap-4 lg:gap-0" data-id="element-189" data-mp="29v035zumih8o" data-mpi={index}>
                <div className="flex-1 bg-engage-gray1 border border-engage-gray2 rounded-lg p-6 h-full flex flex-col" data-id="element-190" data-mp="2ntq7o0jrvj72">
                  <span className="text-engage-yellow text-xs font-bold uppercase tracking-[0.15em] mb-3" data-id="element-191" data-mp="thtfg5dia9ay">
                    {item.label}
                  </span>
                  <p className="text-engage-white text-lg font-semibold leading-snug flex-grow" data-id="element-192" data-mp="okjfvwwekh9e">
                    {item.title}
                  </p>
                  {item.duration && <span className="text-engage-gray4 text-sm mt-3" data-id="element-193" data-mp="uxdwtlvng6rj">
                      {item.duration}
                    </span>}
                </div>
                {index < HIRING_STEPS.length - 1 && <ChevronRight className="w-5 h-5 text-engage-gray3 shrink-0 rotate-90 lg:rotate-0 lg:mx-3" aria-hidden="true" data-id="element-194" data-mp="14us9daegcbek" />}
              </li>)}
          </ol>

          <p className="text-engage-gray4 text-base md:text-lg leading-relaxed max-w-3xl" data-id="element-195" data-mp="h6safn6zleow">
            About 2 hours of your time total, spread over a week. You hear back
            within 3 business days at every step, yes or no. One more thing:
            when you reach the written questions, start your first answer with
            the word Machine. That's how we know you read this page.
          </p>
        </div>
      </section>

      {/* Application Form */}
      <section aria-labelledby="apply" className="py-20 md:py-28 px-4" data-id="element-196" data-mp="3d48apotd15tq">
        <div className="max-w-3xl mx-auto" data-id="element-197" data-mp="3d2x8vujh6859">
          <h2 id="apply" className="text-3xl md:text-4xl font-bold text-engage-white mb-3" data-id="element-198" data-mp="384nbddaa2vgh">
            Apply
          </h2>
          <p className="text-engage-gray4 text-base md:text-lg mb-10" data-id="element-199" data-mp="2z506ghicb7io">
            Takes about 10 minutes. No cover letter.
          </p>
          <ApplicationWizard data-id="element-200" data-mp="2ud8qf0wt8k6s" />
        </div>
      </section>
    </div>;
}